import { SELF_HOSTED } from "@/config"

export const isSelfHosted = () => !!SELF_HOSTED

export const getVersions = () =>
  SELF_HOSTED || {
    microKosmosVersion: undefined
  }

export const getMicroKosmosVersion = () => getVersions().microKosmosVersion

export const getSlugSelfHosted = () => {
  if (!SELF_HOSTED) return undefined

  return SELF_HOSTED.slug?.toLowerCase()
}
